// Active signup flow. `plan` and `payment` are intentionally absent — the
// billing surface is paused while the plan/billing APIs are still being
// built, but the step components (NtOnboardingPlanStep, NtOnboardingPaymentStep)
// and `onboardingPlans` below are left in the tree so re-enabling them later
// is a one-line change in this array.
export const onboardingSteps = [
  { key: "welcome", title: "Welcome", icon: "rocket-launch-outline", canSkip: false },
  { key: "company", title: "Company", icon: "domain", canSkip: false },
  { key: "admin",   title: "Admin",   icon: "account-outline", canSkip: false },
  { key: "review",  title: "Review",  icon: "clipboard-check-outline", canSkip: false },
  { key: "verify",  title: "Verify",  icon: "email-check-outline", canSkip: false },
];

// Placeholder catalog rendered on the Plan step until the billing backend
// surface is ready. Prices, features and limits are illustrative.
export const onboardingPlans = [
  {
    id: "starter",
    name: "Starter",
    tagline: "For small teams getting started",
    price: 19,
    priceSuffix: "user / month",
    seats: 10,
    features: [
      "Up to 10 extensions",
      "Voicemail to email",
      "Internal calling (ext-to-ext)",
      "Web softphone",
    ],
  },
  {
    id: "pro",
    name: "Pro",
    tagline: "Most teams pick this one",
    price: 39,
    priceSuffix: "user / month",
    seats: 50,
    features: [
      "Up to 50 extensions",
      "Ring groups + IVR menus",
      "Voicemail transcription",
      "Outside calling (PSTN, SMS)",
    ],
    recommended: true,
  },
  {
    id: "business",
    name: "Business",
    tagline: "Scale + advanced features",
    price: 79,
    priceSuffix: "user / month",
    seats: null, // unlimited
    features: [
      "Unlimited extensions",
      "Call recording + analytics",
      "Priority support · 1h SLA",
      "Multi-region failover",
    ],
  },
];
